import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-editor-block',{attrs:{"identifier":_vm.identifier,"type":"text","contentAttr":"content"},scopedSlots:_vm._u([{key:"default",fn:function({ content }){return [(content && content!=='is_inactive')?_c('div',{staticClass:"text-block",domProps:{"innerHTML":_vm._s(_vm.$sanitize(content))}}):_vm._e(),(!content && content!=='is_inactive')?_c(VSkeletonLoader,{attrs:{"type":"paragraph"}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }